/**
* GENERATED BY RPC GEN - LESS MODIFY BY HAND
* report-service.ts  2023-11-13T18:19:31+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'bt-rpc-base';

import type { Report } from './discuss-dto';

const _ = 'Report/';

export class ReportService {

  constructor(readonly r: RpcService) {}
  // 举报主题或者回复
  report(d:Report, m?: M): R<boolean>{
    return this.r.async(_ + 'report', d, m);
  }
}
